import { useSelector } from 'react-redux';
import { getBreakpoints } from '../breakpoints/selectors';
export var useBreakpoints = function () {
    var _a = useSelector(getBreakpoints), isMobileOrSmaller = _a.isMobileOrSmaller, isTabletOrSmaller = _a.isTabletOrSmaller, isLaptopOrSmaller = _a.isLaptopOrSmaller, currentWidth = _a.currentWidth;
    return {
        isMobileOrSmaller: isMobileOrSmaller,
        isTabletOrSmaller: isTabletOrSmaller,
        isLaptopOrSmaller: isLaptopOrSmaller,
        currentWidth: currentWidth,
    };
};
